import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { AuthRefreshSuccessResponse } from '@/modules/Auth/types/api'

export const REFRESH_TOKEN_ENDPOINT = 'admin/Auth/refresh-token'

export async function refreshMutation(payload: {
  accessToken: string
  refreshToken: string
}) {
  return axiosInstance.post<AuthRefreshSuccessResponse>(
    REFRESH_TOKEN_ENDPOINT,
    payload
  )
}
